import Checkbox from '@atlaskit/checkbox';
import { key, subscribeTo } from '@databases/ping-registry';
import React, { useEffect, useState } from 'react';

type HeaderCheckboxState = 'checked' | 'indeterminate' | 'unchecked';

/**
 * This component is rendered when the databasesSelectionsPerformance experiment flag is enabled.
 * Input events are captured by the selections package for optimized performance.
 *
 * Uses Atlaskit Checkbox in controlled mode (`isChecked`, `isIndeterminate`) — state
 * is synchronized through the ping registry, which bridges the selections effect
 * and React cleanly.
 *
 * Ping subscription**: After mount, subscribes to the ping registry for
 * header checkbox state changes. The checkbox effect computes the aggregate
 * state (checked/indeterminate/unchecked) and notifies the registry on each delta.
 */
const SelectionsHeaderCheckbox = () => {
  const [headerState, setHeaderState] = useState<HeaderCheckboxState>('unchecked');

  useEffect(() => {
    const headerKey = key('headerCheckbox', {});

    return subscribeTo(headerKey, 'state', (state: HeaderCheckboxState) => {
      setHeaderState(state);
    });
  }, []);

  return (
    <Checkbox
      id="selections-header-checkbox"
      isChecked={headerState === 'checked'}
      isIndeterminate={headerState === 'indeterminate'}
    />
  );
};

export default SelectionsHeaderCheckbox;
